import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Search } from '@material-ui/icons';
import MenuIcon from '@material-ui/icons/Menu';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import { inject, observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';

@inject('store')
@observer
class DashBoardHeader extends Component {
  constructor(props) {
    super(props);
    this.dashBoardStore = props.store.dashBoardStore;
  }

  handleSearchChange = (e) => {
    this.dashBoardStore.setSearchString(e.target.value);
  };

  toggleSidebar = () => {
    this.dashBoardStore.toggleSidebar();
  };

  render() {
    const { searchString } = this.dashBoardStore;

    return (
      <AppBar position="fixed">
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="Menu"
            onClick={this.toggleSidebar}
          >
            <MenuIcon />
          </IconButton>
          <Grid container justify="space-between" alignItems="center">
            <Grid item xs={6}>
              <Typography variant="title" color="inherit">
                Feedbot
              </Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Paper>
                <TextField
                  value={searchString}
                  onChange={this.handleSearchChange}
                  placeholder="Search..."
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                />
              </Paper>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    );
  }
}

export default DashBoardHeader;



// WEBPACK FOOTER //
// ./src/components/home/DashBoardHeader.js